<div class="dx-fieldset">
  <dx-validation-group *ngIf="model" id="productValidationGroup">
    <div class="dx-fieldset grid-view" *ngIf="modelService.loginService.hasAddonElectronicSales">

      <div class="dx-fieldset">
        <div class="dx-fieldset-header">Artikel</div>
        <div class="np-field">
          <np-inputControl [showLinkButtons]="false" [showPlaceLabel]="true"
            labelText="{{ 'ELECTRONIC_SALES_DATE_CREATED' | translate }}" field="DATE_CREATED" [suppressLinkButton]="true"
            [suppressPlaceLabel]="true" [suppressDragHandle]="true">

            <div slot="content" class="contentSlot">
              <dx-date-box [min]="minDate" [max]="now" [(value)]="model.electronicSales.dateCreated"
                [showClearButton]="true" (onValueChanged)="update($event, 'ELECTRONIC_SALES_DATE_CREATED')">
                <dx-validator *ngIf="!templateView" validationGroup="productValidationGroup">
                  <dxi-validation-rule type="async"
                    [validationCallback]="validationService.validateField('ELECTRONIC_SALES_DATE_CREATED')"></dxi-validation-rule>
                </dx-validator>
              </dx-date-box>
            </div>

          </np-inputControl>
        </div>

        <div class="np-field">
          <np-inputControl [showLinkButtons]="false" [showPlaceLabel]="true"
            labelText="{{ 'ELECTRONIC_SALES_NEWINSHOP_TIME' | translate }}" field="NEWINSHOP_TIME"
            [suppressLinkButton]="true" [suppressPlaceLabel]="true" [suppressDragHandle]="true">

            <div slot="content" class="contentSlot">
              <dx-date-box [min]="minDate" [max]="now" [(value)]="model.electronicSales.newInShopTime"
                [showClearButton]="true" (onValueChanged)="update($event, 'ELECTRONIC_SALES_NEWINSHOP_TIME')">
                <dx-validator *ngIf="!templateView" validationGroup="productValidationGroup">
                  <dxi-validation-rule type="async"
                    [validationCallback]="validationService.validateField('ELECTRONIC_SALES_NEWINSHOP_TIME')"></dxi-validation-rule>
                </dx-validator>
              </dx-date-box>
            </div>

          </np-inputControl>
        </div>

        <div *ngFor="let kv of othersMap | keyvalue">
          <div class="np-field">
            <np-inputControl [showLinkButtons]="false" [showPlaceLabel]="true" [suppressLinkButton]="true"
              [suppressPlaceLabel]="true" [suppressDragHandle]="true"
              labelText="{{ kv.key | translate }}" field="{{ kv.key }}">

              <div slot="content" class="contentSlot">
                <dx-text-box [(value)]="model.electronicSales[kv.value]" [min]="0"
                  (onValueChanged)="update($event, kv.key)">
                  <dx-validator *ngIf="!templateView" validationGroup="productValidationGroup">
                    <dxi-validation-rule type="async"
                      [validationCallback]="validationService.validateField(kv.key)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>

            </np-inputControl>
          </div>
        </div>

        <div *ngFor="let kv of validationService.fieldNames.electronicSalesBoolMapping | keyvalue">
          <div class="np-field">
            <np-inputControl [showLinkButtons]="false" [showPlaceLabel]="true" [suppressLinkButton]="true"
              [suppressPlaceLabel]="true" [suppressDragHandle]="true"
              labelText="{{ kv.key | translate }}" field="{{ kv.key }}">

              <div slot="content" class="contentSlot">
                <dx-switch [(value)]="model.electronicSales[kv.value]" (onValueChanged)="update($event, kv.key)">
                  <dx-validator *ngIf="!templateView" validationGroup="productValidationGroup">
                    <dxi-validation-rule type="async" [validationCallback]="validationService.validateField(kv.key)"></dxi-validation-rule>
                  </dx-validator>
                </dx-switch>
              </div>

            </np-inputControl>
          </div>
        </div>
      </div>

      <div class="dx-fieldset">
        <div class="dx-fieldset-header">Marketing</div>
        <div class="np-field">
          <np-inputControl [showLinkButtons]="false" 
                           [showPlaceLabel]="true" 
                           [suppressLinkButton]="true"
                           [suppressPlaceLabel]="true" 
                           [suppressDragHandle]="true"
                           labelText="{{ 'ELECTRONIC_SALES_SUMMARY_TEXT' | translate }}" field="SUMMARY_TEXT">
    
            <div slot="content" class="contentSlot">
              <div *ngIf="showHTMLEditor &&  !isPrint" class="w-100">
                <dx-html-editor class="w-100"
                                [(value)]="model.electronicSales.summaryText"
                                placeholder="SUMMARY_TEXT"
                                (onFocusOut)="update($event, 'ELECTRONIC_SALES_SUMMARY_TEXT')"
                                allowSoftLineBreak="true">
                  <dxo-toolbar>
                    <dxi-item name="undo"></dxi-item>
                    <dxi-item name="redo"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="bold"></dxi-item>
                    <dxi-item name="italic"></dxi-item>
                    <dxi-item name="strike"></dxi-item>
                    <dxi-item name="underline"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="alignLeft"></dxi-item>
                    <dxi-item name="alignCenter"></dxi-item>
                    <dxi-item name="alignRight"></dxi-item>
                    <dxi-item name="alignJustify"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="header" [acceptedValues]="[1, 2, 3, 4, 5, false]"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="orderedList"></dxi-item>
                    <dxi-item name="bulletList"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="link"></dxi-item>
                  </dxo-toolbar>
                  <dx-validator *ngIf="!templateView" validationGroup="productValidationGroup">
                    <dxi-validation-rule type="async" [validationCallback]="validationService.validateField('SUMMARY_TEXT')"></dxi-validation-rule>
                  </dx-validator>
                </dx-html-editor>
              </div>
    
              <div *ngIf="!showHTMLEditor || isPrint">
                <label class="placeLabel {{ model?.electronicSales?.summaryText?.length>0 ? 'placeLabelSmall' : '' }}">SUMMARY_TEXT</label>
                <dx-text-area [(value)]="model.electronicSales.summaryText"
                              [height]="130"
                              (onValueChanged)="update($event, 'ELECTRONIC_SALES_SUMMARY_TEXT')">
                  <dx-validator *ngIf="!templateView" validationGroup="productValidationGroup">
                    <dxi-validation-rule type="async" [validationCallback]="validationService.validateDescriptionLong"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-area>
              </div>
            </div>
          </np-inputControl>
        </div>

        <div class="np-field">
          <np-inputControl [showLinkButtons]="false" [showPlaceLabel]="true"
            labelText="{{ 'ELECTRONIC_SALES_NOTE_CUSTOMER' | translate }}" field="NOTE_CUSTOMER"
            [suppressLinkButton]="true" [suppressPlaceLabel]="true" [suppressDragHandle]="true">

            <div slot="content" class="contentSlot">
              <dx-text-box [(value)]="model.electronicSales.noteCustomer" [showClearButton]="true"
                (onValueChanged)="update($event, 'ELECTRONIC_SALES_NOTE_CUSTOMER')">
                <dx-validator *ngIf="!templateView" validationGroup="productValidationGroup">
                  <dxi-validation-rule type="async" [validationCallback]="validationService.validateField('ELECTRONIC_SALES_NOTE_CUSTOMER')"></dxi-validation-rule>
                </dx-validator>
              </dx-text-box>
            </div>

          </np-inputControl>
        </div>
        <div *ngFor="let kv of marketingMap | keyvalue">
          <div class="np-field">
            <np-inputControl [showLinkButtons]="false" [showPlaceLabel]="true" [suppressLinkButton]="true"
              [suppressPlaceLabel]="true" [suppressDragHandle]="true"
              labelText="{{ kv.key | translate }}" field="{{ kv.key }}">

              <div slot="content" class="contentSlot">
                <dx-text-box [(value)]="model.electronicSales[kv.value]" (onValueChanged)="update($event, kv.key)">
                  <dx-validator *ngIf="!templateView" validationGroup="productValidationGroup">
                    <dxi-validation-rule type="async"
                      [validationCallback]="validationService.validateField(kv.key)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>

            </np-inputControl>
          </div>
        </div>
        <div class="np-field">
          <np-inputControl [showLinkButtons]="false" [showPlaceLabel]="true" [suppressLinkButton]="true"
            [suppressPlaceLabel]="true" [suppressDragHandle]="true"
            labelText="{{ 'ELECTRONIC_SALES_SEOURL_FILENAME' | translate }}" field="ELECTRONIC_SALES_SEOURL_FILENAME">

            <div slot="content" class="contentSlot">
              <dx-text-box
                [(value)]="model.electronicSales.seoUrlFilename"
                (onValueChanged)="update($event, 'ELECTRONIC_SALES_SEOURL_FILENAME')"
                
                >
                <dx-validator *ngIf="!templateView" validationGroup="productValidationGroup">
                  <dxi-validation-rule type="async" [validationCallback]="validationService.validateField('ELECTRONIC_SALES_DATE_CREATED')"></dxi-validation-rule>
                </dx-validator>
              </dx-text-box>
            </div>

          </np-inputControl>
        </div>
        <div *ngFor="let kv of productDetail | keyvalue">
          <div class="np-field">
            <np-inputControl [showLinkButtons]="false" [showPlaceLabel]="true" [suppressLinkButton]="true"
              [suppressPlaceLabel]="true" [suppressDragHandle]="true"
              labelText="{{ 'ElectronicSales_' + kv.value | translate }}" field="{{ kv.key }}">

              <div slot="content" class="contentSlot">
                <dx-text-box [(value)]="model.electronicSales[kv.value]" (onValueChanged)="update($event, kv.key)">
                  <dx-validator *ngIf="!templateView" validationGroup="productValidationGroup">
                    <dxi-validation-rule type="async" [validationCallback]="validationService.validateField(kv.key)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>

            </np-inputControl>
          </div>
        </div>
      </div>

      <div class="dx-fieldset">
        <div class="dx-fieldset-header">{{'Klassifizierungen' | translate}}</div>
        <div *ngFor="let kv of classificationMap | keyvalue">
          <div class="np-field">
            <np-inputControl [showLinkButtons]="false" [showPlaceLabel]="true" [suppressLinkButton]="true"
              [suppressPlaceLabel]="true" [suppressDragHandle]="true"
              labelText="{{ 'ElectronicSales_' + kv.value | translate }}" field="{{ kv.key }}">

              <div slot="content" class="contentSlot">
                <dx-text-box [(value)]="model.electronicSales[kv.value]" (onValueChanged)="update($event, kv.key)">
                  <dx-validator *ngIf="!templateView" validationGroup="productValidationGroup">
                    <dxi-validation-rule type="async" [validationCallback]="validationService.validateField(kv.key)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>

            </np-inputControl>
          </div>
        </div>
      </div>

      <div class="dx-fieldset">
        <div class="dx-fieldset-header">Richtlinien</div>
        <div *ngFor="let kv of guidelinesMap | keyvalue">
          <div class="np-field">
            <np-inputControl [showLinkButtons]="false" [showPlaceLabel]="true" [suppressLinkButton]="true"
              [suppressPlaceLabel]="true" [suppressDragHandle]="true"
              labelText="{{ 'ElectronicSales_' + kv.value | translate }}" field="{{ kv.key }}">

              <div slot="content" class="contentSlot">
                <dx-text-box [(value)]="model.electronicSales[kv.value]" (onValueChanged)="update($event, kv.key)">
                  <dx-validator *ngIf="!templateView" validationGroup="productValidationGroup">
                    <dxi-validation-rule type="async" [validationCallback]="validationService.validateField(kv.key)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>

            </np-inputControl>
          </div>
        </div>
      </div>

      <div class="dx-fieldset">
        <div class="dx-fieldset-header">Lager/Logistik</div>
        <div *ngFor="let kv of logisticsMap | keyvalue">
          <div class="np-field">
            <np-inputControl [showLinkButtons]="false" [showPlaceLabel]="true" [suppressLinkButton]="true"
              [suppressPlaceLabel]="true" [suppressDragHandle]="true"
              labelText="{{ kv.key | translate }}" field="{{ kv.key }}">

              <div slot="content" class="contentSlot">
                <dx-text-box [(value)]="model.electronicSales[kv.value]" (onValueChanged)="update($event, kv.key)">
                  <dx-validator *ngIf="!templateView" validationGroup="productValidationGroup">
                    <dxi-validation-rule type="async" [validationCallback]="validationService.validateField(kv.key)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>

            </np-inputControl>
          </div>
        </div>
      </div>

      <div class="dx-fieldset">
        <div class="dx-fieldset-header">Zuschläge/Kosten</div>
        <div *ngFor="let kv of chargesMap | keyvalue">
          <div class="np-field">
            <np-inputControl [showLinkButtons]="false" [showPlaceLabel]="true" [suppressLinkButton]="true"
              [suppressPlaceLabel]="true" [suppressDragHandle]="true"
              labelText="{{ kv.key | translate }}" field="{{ kv.key }}">

              <div slot="content" class="contentSlot">
                <dx-text-box [(value)]="model.electronicSales[kv.value]" (onValueChanged)="update($event, kv.key)">
                  <dx-validator *ngIf="!templateView" validationGroup="productValidationGroup">
                    <dxi-validation-rule type="async" [validationCallback]="validationService.validateField(kv.key)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>

            </np-inputControl>
          </div>
        </div>
      </div>

      <div class="dx-fieldset">
        <div class="dx-fieldset-header">Bestellung</div>

        <np-inputControl [showLinkButtons]="false" [showPlaceLabel]="true" [suppressLinkButton]="true"
          [suppressPlaceLabel]="true" [suppressDragHandle]="true"
          labelText="{{ 'ELECTRONIC_SALES_ORDER_DECIMAL_PLACES' | translate }}" field="ORDER_DECIMAL_PLACES">

          <div slot="content" class="contentSlot">
            <dx-number-box [(value)]="model.electronicSales.orderDecimalPlaces" [min]="0.0" format="#0.##"
              (onValueChanged)="update($event, 'ELECTRONIC_SALES_ORDER_DECIMAL_PLACES')">
              <dx-validator *ngIf="!templateView" validationGroup="productValidationGroup">
                <dxi-validation-rule type="async" [validationCallback]="validationService.validateField('ELECTRONIC_SALES_ORDER_DECIMAL_PLACES')"></dxi-validation-rule>
              </dx-validator>
            </dx-number-box>
          </div>

        </np-inputControl>

        <div *ngFor="let kv of ordersMap | keyvalue">
          <div class="np-field">
            <np-inputControl [showLinkButtons]="false" [showPlaceLabel]="true" [suppressLinkButton]="true"
              [suppressPlaceLabel]="true" [suppressDragHandle]="true"
              labelText="{{ kv.key | translate }}" field="{{ kv.key }}">

              <div slot="content" class="contentSlot">
                <dx-number-box [(value)]="model.electronicSales[kv.value]" [min]="0.0" format="#0.##"
                  (onValueChanged)="update($event, kv.key)">
                  <dx-validator *ngIf="!templateView" validationGroup="productValidationGroup">
                    <dxi-validation-rule type="async" [validationCallback]="validationService.validateField(kv.key)"></dxi-validation-rule>
                  </dx-validator>
                </dx-number-box>
              </div>

            </np-inputControl>
          </div>
        </div>
      </div>
    </div>
  </dx-validation-group>
</div>
